var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal-component", {
    attrs: {
      id: "autorenewaLearnMoreModal",
      shown: _vm.shown,
      "handle-cancel": _vm.close,
      size: "lg",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v("\n        " + _vm._s(_vm.i18n.learnMoreTitle) + "\n    "),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                _vm._s(_vm.i18n.learnMoreIntro) +
                  " " +
                  _vm._s(_vm.freeCouponThreshold) +
                  " " +
                  _vm._s(_vm.i18n.learnMoreIntro2)
              ),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.i18n.learnMoreActivateListTitle))]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [_vm._v(_vm._s(_vm.i18n.learnMoreActivateList[0]))]),
              _vm._v(" "),
              _c("li", [_vm._v(_vm._s(_vm.i18n.learnMoreActivateList[1]))]),
              _vm._v(" "),
              _c("li", [_vm._v(_vm._s(_vm.i18n.learnMoreActivateList[2]))]),
              _vm._v(" "),
              _c("li", [_vm._v(_vm._s(_vm.i18n.learnMoreActivateList[3]))]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mt-2" }, [
              _vm._v(_vm._s(_vm.i18n.learnMoreCancelListTitle)),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.i18n.learnMoreCancelListSubtitle))]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [_vm._v(_vm._s(_vm.i18n.learnMoreCancelList[0]))]),
              _vm._v(" "),
              _c("li", [_vm._v(_vm._s(_vm.i18n.learnMoreCancelList[1]))]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mt-2" }, [
              _c("small", [_vm._v(_vm._s(_vm.i18n.learnMoreFootnote))]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-block",
                attrs: { type: "button" },
                on: { click: _vm.close },
              },
              [_vm._v("\n            " + _vm._s(_vm.i18n.ok) + "\n        ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }